<template>
    <div class="animated fadeIn">
        <b-card>
            <v-server-table :url="apiurl('lead/table')"  :columns="columns" :options="options" :theme="theme" id="leadsTable" name="leadsTable24">
                <a slot="uri" slot-scope="props" :data="data" target="_blank" :href="props.row.uri" class="icon-eye">w</a>
                <div slot="child_row" slot-scope="props">

                </div>
            </v-server-table>
        </b-card>
    </div>
</template>

<script>

    import Vue from 'vue'
    import VueJsonPretty from 'vue-json-pretty'
    import {ClientTable, ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import created_at from '../jsx/leads/created_at'

    Vue.use(ClientTable)
    Vue.use(ServerTable)

    export default {
        name: 'NsbTechRoomServices',
        components: {
            ClientTable,
            ServerTable,
            Event,
            VueJsonPretty
        },
        mixins: [functions],
        data: function () {
            return {
                data:[],
                columns: ['id', 'created_at', 'company_id', 'user_id', 'creator_id', 'status', 'class', 'name', 'email', 'phone', 'title' ],
                dateColumns:['created_at'],
                options: {
                    saveState: true,
                    headings: {
                        id: '#',
                        created_at: 'дата/время',
                        company_id: 'дата/время',
                        user_id: 'владелец',
                        creator_id: 'создатель',
                        status: 'статус',
                        name: 'имя',
                        email: 'email',
                        phone: 'телефон',
                        title: 'заголовок',
                    },
                    sortable: ['id', 'created_at'],
                    filterable: ['id', 'created_at', 'company_id', 'user_id', 'creator_id', 'status', 'class', 'name', 'email', 'phone', 'title' ],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll'
                    },
                    filterByColumn: true,
                    templates: {
                        created_at
                    },
                    debounce: CONSTANTS.DEBOUNCE,
                },
                theme: 'bootstrap4',
                template: 'default'
            }
        },
        methods: {
        },
        created: function() {
        }
    };
</script>

<style lang="scss">

</style>
